import { ApplicantDetailsResponse } from "@modules/application-section/application-details/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApplicationDetails,
  getApplicationDetailsROW,
  getFileUploadSignedUrl,
  generateEsignRequest,
  getTemplateDocument,
  uploadedDocuments,
  getRegionalOfficeDetails,
  postCompleteEsignProvisional,
  getTransactionStatus,
  getReceiptDetails,
  getbgDetails,
  getpaDetails,
  uploadFileWithFormData,
} from "../../services/apiEndpoints";

export const fetchApplicationDetails = createAsyncThunk<
  ApplicantDetailsResponse,
  number
>("payment/fetchApplicationDetails", async (access_id) => {
  try {
    const response = await getApplicationDetails({
      access_id,
    }); 
    return response.data.data;
  } catch (error: any) {
    return error;
  }
});

export const fetchApplicationDetailsRow = createAsyncThunk<
  ApplicantDetailsResponse,
  number
>("payment/fetchApplicationDetailsRow", async (access_id) => {
  try {
    const response = await getApplicationDetailsROW({
      access_id,
    });

    return response.data.data;
  } catch (error: any) {
    return error;
  }
});

export const getUploadSignedURLThunk = createAsyncThunk(
  "payment/getUploadSigned",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await getFileUploadSignedUrl(
        payload.filename,
        payload.moduletype,
        payload.fileSize,
        payload.contentType,
      ); 
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const uploadFileWithFormDataThunk = createAsyncThunk(
  "payment/uploadFileWithFormData",
  async (
    { payload, isEsign }: { payload: any; isEsign?: boolean },
    { rejectWithValue },
  ) => {
    try {
      const response = await uploadFileWithFormData(payload, isEsign);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const generateEsignRequestThunk = createAsyncThunk(
  "payment/generateEsignRequest",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await generateEsignRequest(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getTemplateDocumentThunk = createAsyncThunk(
  "payment/getTemplateDocument",
  async (applicationId: number, { rejectWithValue }) => {
    try {
      const response = await getTemplateDocument(applicationId);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const fetchUploadedDocuments = createAsyncThunk(
  "payment/fetchUploadDocuments",
  async ({
    access_id,
    amenityCategory,
  }: {
    access_id: number;
    amenityCategory: number;
  }) => {
    try {
      const response = await uploadedDocuments({
        access_id: access_id,
        module_type: "access",
        category_id: amenityCategory,
      });
      return response.data.data;
    } catch (error: any) {
      // return thunkAPI.rejectWithValue(
      //   error.response?.data || error.message || "Failed to load documents"
      // );
    }
  },
);
export const fetchROWUploadedDocuments = createAsyncThunk(
  "payment/fetchROWUploadedDocuments",
  async ({
    access_id,
    amenityCategory,
  }: {
    access_id: number | string;
    amenityCategory: number;
  }) => {
    try {
      const response = await uploadedDocuments({
        access_id: access_id,
        module_type: "row",
        category_id: amenityCategory,
      });
      return response.data.data;
    } catch (error: any) {
      // return thunkAPI.rejectWithValue(
      //   error.response?.data || error.message || "Failed to load documents"
      // );
    }
  },
);

export const postCompleteEsignProvisionalThunk = createAsyncThunk<any, any>(
  "details/postCompleteEsignProvisional",
  async (payload: any) => {
    try {
      const response = await postCompleteEsignProvisional(payload);
      return response.data;
    } catch (error: any) {}
  },
);

export const fetchRegionalOfficeDetails = createAsyncThunk(
  "details/fetchRegionalOfficeDetails",
  async (access_id: number) => {
    try {
      const response = await getRegionalOfficeDetails({ access_id });
      return response.data.data;
    } catch (error: any) {}
  },
);

export const getTransactionStatusThunk = createAsyncThunk(
  "details/getTransactionStatus",
  async (application_id: number) => {
    try {
      const response = await getTransactionStatus({ application_id });
      return response.data.data;
    } catch (error: any) {}
  },
);

export const fetchReceiptDetailsThunk = createAsyncThunk(
  "receipt-details",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getReceiptDetails(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
// fetchbankguaranteedetailsThunk

export const fetchbankguaranteedetailsThunk = createAsyncThunk(
  "bank-guarantee-details",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getbgDetails(id);
      return response?.data?.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const fetchpadetailsThunk = createAsyncThunk(
  "pa-details",
  async (id: number, { rejectWithValue }) => { 
    try {
      const response = await getpaDetails(id);
      return response?.data?.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
